module.exports = __webpack_public_path__ + "img/dw_gongjiao.010900d9.png";